import { Form, Modal, Select } from 'antd';

import { useProductsImport } from '@app/pages/Warehouses/Products/hooks';

import type { FC } from 'react';

export const ProductsImport: FC = () => {
  const {
    inputRef,
    openWarehouseModal,
    isWarehouseModalOpen,
    closeWarehouseModal,
    confirmWarehouseModal,
    handleFileChange,
    warehousesOptions,
    isWarehousesFetching,
    selectedWarehouseId,
    setSelectedWarehouseId,
  } = useProductsImport();

  return (
    <>
      <div onClick={openWarehouseModal} className="unselectable">
        <span data-testid="import-products">Импорт из файла</span>
      </div>
      <input
        ref={inputRef}
        type="file"
        style={{ display: 'none' }}
        accept=".xlsx, .xls"
        onChange={handleFileChange}
      />

      <Modal
        open={isWarehouseModalOpen}
        onCancel={closeWarehouseModal}
        onOk={confirmWarehouseModal}
        okText="Продолжить"
        cancelText="Отменить"
        okButtonProps={{ disabled: !selectedWarehouseId }}
        title="Выберите склад для импорта"
        destroyOnHidden
      >
        <Form layout="vertical">
          <Form.Item label="Склад" required>
            <Select
              showSearch
              optionFilterProp="label"
              placeholder="Выберите склад"
              loading={isWarehousesFetching}
              options={warehousesOptions}
              value={selectedWarehouseId ?? undefined}
              onChange={setSelectedWarehouseId}
              data-testid="import-warehouse-select"
            />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};
